import EyeIcon from "@/assets/colorable/eye.svg?react";
import EyeCrossedIcon from "@/assets/colorable/eye_crossed.svg?react";
import InputField from "@/components/Common/forms/InputField";
import {type FC, type ReactNode} from "react";
import {useToggle} from "react-use";

const PasswordField: FC<{
  onChange: (value: string) => void;
  error: string | null | undefined;
  icon?: ReactNode;
  label?: string | ReactNode;
  labelClassName?: string;
  value: string | null;
  placeholder?: string;
  className?: string;
  customFieldId?: string;
  dataTestId?: string;
}> = ({onChange, error = null, label, labelClassName, placeholder, value, className, customFieldId, dataTestId}) => {
  const [isPasswordVisible, togglePasswordVisibility] = useToggle(false);

  return (
    <InputField
      customFieldId={customFieldId}
      dataTestId={dataTestId}
      onChange={onChange}
      className={className}
      error={error}
      value={value ?? ""}
      label={label}
      labelClassName={labelClassName}
      placeholder={placeholder}
      type={isPasswordVisible ? "text" : "password"}
      icon={
        <button onClick={togglePasswordVisibility} className="absolute top-0 right-0 bottom-0 h-full pr-4">
          {isPasswordVisible ? (
            <EyeCrossedIcon className="text-neutral-grey-light size-5 shrink-0" />
          ) : (
            <EyeIcon className="text-neutral-grey-light size-5 shrink-0" />
          )}
        </button>
      }
    />
  );
};

export default PasswordField;
